var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audioPlayer",staticClass:"video-js vjs-default-skin"},[_c('source',{attrs:{"src":_vm.src,"type":"audio/x-m4a"}})])}
var staticRenderFns = []

export { render, staticRenderFns }